import { IEcgMeasures } from './interfaces';

export class EcgMeasures implements IEcgMeasures {
    A1: number = 0;
    A2: number = 0;
    deltaT: number = 0;
    deltaA: number = 0;
    HR: number = 0;
}
